export const CONTENT_SECTION_CLASS_BLOCK_NAME = 'bb-content-section';
export const CONTENT_SECTION_HEADER_CLASS_NAME = `${CONTENT_SECTION_CLASS_BLOCK_NAME}__header`;
export const CONTENT_SECTION_TITLE_CLASS_NAME = `${CONTENT_SECTION_CLASS_BLOCK_NAME}__title`;
export const CONTENT_SECTION_TOURNAMENT_LOGO_CLASS_NAME = `${CONTENT_SECTION_CLASS_BLOCK_NAME}__tournament-logo`;
export const CONTENT_SECTION_TOURNAMENT_LOGO_ICON_CLASS_NAME = `${CONTENT_SECTION_TOURNAMENT_LOGO_CLASS_NAME}-icon`;
export const CONTENT_SECTION_TITLE_CONTAINER_CLASS_NAME = `${CONTENT_SECTION_CLASS_BLOCK_NAME}__title-container`;
export const CONTENT_SECTION_TITLE_ITEM_CLASS_NAME = `${CONTENT_SECTION_CLASS_BLOCK_NAME}__title-item`;
export const CONTENT_SECTION_COLLAPSED_CLASS_NAME = `${CONTENT_SECTION_CLASS_BLOCK_NAME}--collapsed`;
const CONTENT_SECTION_CONTAINER_CLASS_NAME = `${CONTENT_SECTION_CLASS_BLOCK_NAME}__content`;
export const CONTENT_SECTION_HIDDEN_CONTAINER_CLASS_NAME = `${CONTENT_SECTION_CONTAINER_CLASS_NAME}--hidden`;
export const CONTENT_SECTION_COLLAPSED_EVENT = 'content-section:collapsed';
export const CONTENT_SECTION_EXPANDED_EVENT = 'content-section:expanded';
export const CONTENT_SECTION_FOOTER_CLASS_NAME = `${CONTENT_SECTION_CLASS_BLOCK_NAME}__footer`;
export const CONTENT_SECTION_LINK_CLASS_NAME = `${CONTENT_SECTION_CLASS_BLOCK_NAME}__link`;
export const CONTENT_SECTION_SEE_ALL_CLASS_NAME = `${CONTENT_SECTION_TITLE_CLASS_NAME}__see-all`;

export const CONTENT_SECTION_MODIFIER_SPORT = 'sport';
export const CONTENT_SECTION_MODIFIER_SPORT_ACCOUNT = 'sport-account';
export const CONTENT_SECTION_MODIFIER_DEFAULT = 'default';
export const CONTENT_SECTION_MODIFIER_SECONDARY = 'secondary';
export const CONTENT_SECTION_MODIFIER_TERTIARY = 'tertiary';
export const CONTENT_SECTION_MODIFIER_QUATERNARY = 'quaternary';
export const CONTENT_SECTION_MODIFIER_COLUMN_HEADERS = 'column-headers';
export const CONTENT_SECTION_MODIFIER_EW_TERMS = 'ew-terms'; // To be used with COLUMN_HEADERS
export const CONTENT_SECTION_MODIFIER_TITLE_TEXT_WRAPPED = 'wrap';

export const GTM_CONTENT_SECTION_ATTR_NAME = 'data-spectate-product';
export const CONTENT_SECTION_MODIFIER_SEE_ALL = 'see-all-title';
export const CONTENT_SECTION_EXPAND = 'expand';
export const CONTENT_SECTION_COLLAPSE = 'collapse';
